<template>
<div class="chapter">
<div class="inner_page">
<div class="body">
<section aria-labelledby="ch1" epub:type="chapter" role="doc-chapter">
<header>
<h1 class="CT" id="ch1"><span aria-label="5" id="pg_5" role="doc-pagebreak"><span href="#/xhtml/contents#ch_1" title="Link target outside of Sample"><b>FORGETTABLE</b></span></span></h1>
</header>
<blockquote>
<p class="pagebreak"> </p>
<p class="VT"><span aria-label="6" id="pg_6" role="doc-pagebreak"><b>TIMELESS</b></span></p>
<p class="V">I see your brave face</p>
<p class="VSB">behind that paint the world views as beauty.</p>
<p class="V">Yes, you’re beautiful.</p>
<p class="V">But I want you to know</p>
<p class="V"><i>I’ve seen your warrior heart, too,</i> and</p>
<p class="V">she is timeless.</p>
<p class="pagebreak"> </p>
<p class="VT"><span aria-label="7" id="pg_7" role="doc-pagebreak"><b>BREASTPLATE</b></span></p>
<p class="V">He will offer his hand,</p>
<p class="V">and your instinct will be to take it</p>
<p class="V">because your breastplate</p>
<p class="VSB">longs for release.</p>
<p class="V">Determine first if he will</p>
<p class="V">suffocate and confine,</p>
<p class="V">or let you breathe freely</p>
<p class="V">while you chase the dreams that inspire you.</p>
</blockquote>
<section epub:type="division">
<p class="pagebreak"> </p>
<h2 class="H1"><span aria-label="8" id="pg_8" role="doc-pagebreak"><b>WHERE TO NEXT?</b></span></h2>
<blockquote>
<p class="V">Many will leave,</p>
<p class="V">not because <i>you aren’t worthy,</i></p>
<p class="V">but because you are more—more than</p>
<p class="V">anything they could hold in their hands.</p>
<p class="V">Try not to mourn their loss.</p>
<p class="V">Do you want the one you would have to</p>
<p class="VSB"><i>drag</i> into battle?</p>
<p class="V">Wait for the one who kisses the hope upon</p>
<p class="V">your forehead. Who steadies your spine with</p>
<p class="V">supportive arms. The one who rubs the fear</p>
<p class="V">from your shoulders and whispers,</p>
<p class="V">“Where to next?”</p>
</blockquote>
</section>
<section epub:type="division">
<p class="pagebreak"> </p>
<h2 class="H1"><span aria-label="9" id="pg_9" role="doc-pagebreak"><b>VACANCY</b></span></h2>
<blockquote>
<p class="V">It hurts.</p>
<p class="V"><i>It always hurts.</i></p>
<p class="V">The more they pull</p>
<p class="V">away, the deeper the blade</p>
<p class="VSB">slides in.</p>
<p class="V">Love is always painful</p>
<p class="V"><i>as it lessens,</i> but the intensity</p>
<p class="V">still grows and pulses like</p>
<p class="V">lights around a vacancy sign.</p>
</blockquote>
</section>
<section epub:type="division">
<p class="pagebreak"> </p>
<h2 class="H1"><span aria-label="10" id="pg_10" role="doc-pagebreak"><b>WIT</b></span></h2>
<blockquote>
<p class="V">Beat them with your wit.</p>
<p class="V">That’s one sword</p>
<p class="V">that most are</p>
<p class="V">incapable of</p>
<p class="V">sharpening.</p>
</blockquote>
</section>
<section epub:type="division">
<p class="pagebreak"> </p>
<h2 class="H1"><span aria-label="11" id="pg_11" role="doc-pagebreak"><b>LIGHT-FILLED DAYS</b></span></h2>
<blockquote>
<p class="V">It is always in the deepest</p>
<p class="V">and darkest of times</p>
<p class="V">that we find ourselves</p>
<p class="V">breaking at their memory.</p>
<p class="V">But remember: when someone</p>
<p class="V">chooses to remain distant</p>
<p class="V">in our times of dark,</p>
<p class="V">they are never worthy</p>
<p class="V">of our light-filled days.</p>
</blockquote>
</section>
<section epub:type="division">
<p class="pagebreak"> </p>
<h2 class="H1"><span aria-label="12" id="pg_12" role="doc-pagebreak"><b>PHANTOM LOVERS</b></span></h2>
<blockquote>
<p class="V">They marched in front of you and let you</p>
<p class="V">carry your burden alone. Ducking out at the</p>
<p class="V">first sign of battle and hiding in back</p>
<p class="V">corridors as the world raged around you.</p>
<p class="V">They shirked the responsibility of a true</p>
<p class="V">partnership because you <i>denied</i> their</p>
<p class="VSB">ownership of you.</p>
<p class="V">These are the ghosts of the past running</p>
<p class="V">through your heart. <i>Phantom lovers</i> who</p>
<p class="V">still squat on your landscape, trying</p>
<p class="V">to transfer your strength to their</p>
<p class="VSB">weak spines.</p>
<p class="V">Evict them.</p>
</blockquote>
</section>
<section epub:type="division">
<p class="pagebreak"> </p>
<h2 class="H1"><span aria-label="13" id="pg_13" role="doc-pagebreak"><b>ALLIANCE</b></span></h2>
<blockquote>
<p class="V">Your alliance with your</p>
<p class="V">self-worth is one that</p>
<p class="V">will get you through</p>
<p class="V">jealousy, lovers who leave,</p>
<p class="V">friends who flee, and death.</p>
<p class="V">Never sever the binds</p>
<p class="V">of the arrangement</p>
<p class="V">that keeps your soul intact.</p>
</blockquote>
</section>
<section epub:type="division">
<p class="pagebreak"> </p>
<h2 class="H1"><span aria-label="14" id="pg_14" role="doc-pagebreak"><b>FORGIVE YOURSELF</b></span></h2>
<blockquote>
<p class="V">When you have lost everything,</p>
<p class="V">and your fists are full of dust,</p>
<p class="V">you will begin to scrape the sins</p>
<p class="V">you hid from your heart.</p>
<p class="V">You will pull the past out</p>
<p class="V">from storage cells,</p>
<p class="V">and poke it with a pitchfork,</p>
<p class="V">somehow thinking that since</p>
<p class="V">you have lost all joy from your life,</p>
<p class="V"><i>you deserve the hell</i></p>
<p class="V"><i>of replaying what you’ve tried to forget.</i></p>
<p class="V">But you don’t deserve the pain</p>
<p class="V">or the <i>continued</i> heartbreak.</p>
<p class="V"><i>Forgive yourself</i>—and begin the healing.</p>
</blockquote>
</section>
<section epub:type="division">
<p class="pagebreak"> </p>
<h2 class="H1"><span aria-label="15" id="pg_15" role="doc-pagebreak"><b>CRIMSON</b></span></h2>
<blockquote>
<p class="V">I am crimson memories</p>
<p class="V">and scarlet blushes.</p>
<p class="V">Valentine kisses</p>
<p class="V">and fire truck sirens.</p>
<p class="V">Cranberry roses</p>
<p class="V">and candy apple bites.</p>
<p class="V">Maroon bruises</p>
<p class="V">and hot poker pain.</p>
<p class="V">Blistered thoughts</p>
<p class="V">and Christmas decorations.</p>
<p class="V">I have every color red</p>
<p class="V">running through my veins</p>
<p class="V">when it comes to you.</p>
<p class="V">But never a stop sign</p>
<p class="V">bleeding red.</p>
</blockquote>
</section>
<section epub:type="division">
<p class="pagebreak"> </p>
<h2 class="H1"><span aria-label="16" id="pg_16" role="doc-pagebreak"><b>LIARS</b></span></h2>
<blockquote>
<p class="V">The only thing they leave you with</p>
<p class="V">is their inability</p>
<p class="VSB">to stay.</p>
<p class="V">And you are left with questions</p>
<p class="V">that you will try, inevitably,</p>
<p class="VSB">to answer.</p>
<p class="V">Don’t listen to yourself.</p>
<p class="V">This is when you begin to lie.</p>
</blockquote>
</section>
<section epub:type="division">
<p class="pagebreak"> </p>
<h2 class="H1"><span aria-label="17" id="pg_17" role="doc-pagebreak"><b>THE FIGHT WITHIN</b></span></h2>
<blockquote>
<p class="V">Maybe all this fighting I’ve endured</p>
<p class="V">was self-inflicted.</p>
<p class="V">Maybe I beat myself up because</p>
<p class="V">I couldn’t stand the weight of his absence</p>
<p class="V">knocking me down.</p>
<p class="V">Maybe I had to justify</p>
<p class="V">what it was about me</p>
<p class="V">that was so easy to walk away from.</p>
</blockquote>
</section>
<section epub:type="division">
<p class="pagebreak"> </p>
<h2 class="H1"><span aria-label="18" id="pg_18" role="doc-pagebreak"><b>GETTING THROUGH THE DAY</b></span></h2>
<blockquote>
<p class="V">You lie in bed and you wonder what you</p>
<p class="V">accomplished today.</p>
<p class="V">Remember that the last 24 hours were a gift,</p>
<p class="V">and you opened the gift slowly and held it</p>
<p class="V">close to your heart. You felt every minute</p>
<p class="V">and your lungs absorbed every second.</p>
<p class="V"><i>Getting through a day</i> is never a failure.</p>
<p class="V">It is a victory.</p>
</blockquote>
</section>
<section epub:type="division">
<p class="pagebreak"> </p>
<h2 class="H1"><span aria-label="19" id="pg_19" role="doc-pagebreak"><b>HIDDEN DESIRES</b></span></h2>
<blockquote>
<p class="V">Keeping our desires hidden subdues their</p>
<p class="V">light, but it in no way extinguishes their</p>
<p class="V">flame. They are always there, warming the</p>
<p class="V">underbelly of your conscious thoughts.</p>
<p class="V">They wield a hot poker at night and make</p>
<p class="V">sleep unbearable.</p>
<p class="V">They sing a cappella with the sad songs on</p>
<p class="V">the radio.</p>
</blockquote>
</section>
<section epub:type="division">
<p class="pagebreak"> </p>
<h2 class="H1"><span aria-label="20" id="pg_20" role="doc-pagebreak"><b>MARROW</b></span></h2>
<blockquote>
<p class="V">He meticulously picked me apart like he</p>
<p class="V">was deboning a chicken for a week’s</p>
<p class="V">worth of meals.</p>
<p class="V">He would compliment my scent, my taste, and</p>
<p class="V">my skin. The parts he approved of, he would</p>
<p class="V">savor. He lingered over my breasts and</p>
<p class="V">thighs and found his way under my ribcage.</p>
<p class="V">But as he explored my deepest layers,</p>
<p class="V">gnawing on my fresh-picked bones, my</p>
<p class="V">marrow did not satisfy his palate.</p>
</blockquote>
</section>
<section epub:type="division">
<p class="pagebreak"> </p>
<h2 class="H1"><span aria-label="21" id="pg_21" role="doc-pagebreak"><b>PRISON SENTENCE</b></span></h2>
<blockquote>
<p class="V">… and when I feel those memories</p>
<p class="V">in the room judging me</p>
<p class="V">with their noses pointed in the air,</p>
<p class="V">I know you have walked</p>
<p class="V">into my space</p>
<p class="V">and charmed the jury</p>
<p class="V">with the same scent that was my undoing.</p>
<p class="V">And I am reminded that even my thoughts</p>
<p class="V">are a prison sentence.</p>
</blockquote>
</section>
<section epub:type="division">
<p class="pagebreak"> </p>
<h2 class="H1"><span aria-label="22" id="pg_22" role="doc-pagebreak"><b>NIGHTTIME SPIRITS</b></span></h2>
<blockquote>
<p class="V">I’ve encountered spirits</p>
<p class="V">during the nighttime hours.</p>
<p class="V">You can learn a lot if you don’t</p>
<p class="V">pull the blankets up</p>
<p class="V">and block the spirits out.</p>
<p class="V">Let them have a chair.</p>
<p class="V">They’re lonely, too.</p>
<p class="V">Maybe they need someone to talk to.</p>
<p class="V">If you face them square in the eye,</p>
<p class="V"><i>they aren’t so scary.</i></p>
<p class="V">Then maybe your heart will get</p>
<p class="V">the rest it needs.</p>
</blockquote>
</section>
<section epub:type="division">
<p class="pagebreak"> </p>
<h2 class="H1"><span aria-label="23" id="pg_23" role="doc-pagebreak"><b>DAZZLE</b></span></h2>
<blockquote>
<p class="V">Let’s show them that femininity</p>
<p class="V">can be daring and strong.</p>
<p class="V">Dazzling amid surrounding wreckage.</p>
<p class="V">Pink lipped and quick tongued.</p>
</blockquote>
</section>
<section epub:type="division">
<p class="pagebreak"> </p>
<h2 class="H1"><span aria-label="24" id="pg_24" role="doc-pagebreak"><b>SURVIVOR</b></span></h2>
<blockquote>
<p class="V">We are not barbarians.</p>
<p class="V">We are contained ferocity.</p>
<p class="V">What happens when you</p>
<p class="V">keep something caged</p>
<p class="V">and limit its ability to fly?</p>
<p class="V">If it is a survivor, it learns</p>
<p class="V">to pick the lock.</p>
</blockquote>
</section>
<section epub:type="division">
<p class="pagebreak"> </p>
<h2 class="H1"><span aria-label="25" id="pg_25" role="doc-pagebreak"><b>THE DEVIL’S TRIANGLE</b></span></h2>
<blockquote>
<p class="V">If you are off my radar,</p>
<p class="V">you exist in the oblivion</p>
<p class="V">of places I will never visit.</p>
<p class="VSB">I will never search you out.</p>
<p class="V">The Devil’s Triangle—</p>
<p class="V">I will not waste my time</p>
<p class="V">exploring. There is no reward</p>
<p class="V">for seeking what is</p>
<p class="V">toxic to my future.</p>
</blockquote>
</section>
<section epub:type="division">
<p class="pagebreak"> </p>
<h2 class="H1"><span aria-label="26" id="pg_26" role="doc-pagebreak"><b>ARROWS</b></span></h2>
<blockquote>
<p class="V">Every arrow she shoots from restrained</p>
<p class="V">hands is toward a future she never</p>
<p class="V">thought possible—until now.</p>
</blockquote>
</section>
<section epub:type="division">
<p class="pagebreak"> </p>
<h2 class="H1"><span aria-label="27" id="pg_27" role="doc-pagebreak"><b>GUISE OF PEACE</b></span></h2>
<blockquote>
<p class="V">There were times when the enemy was</p>
<p class="V">sleeping, and she would lower her shield.</p>
<p class="V">She would gather her thoughts and think</p>
<p class="V">about what began the war; back before she</p>
<p class="V">had to tiptoe across bombs that made her</p>
<p class="V">heart explode.</p>
<p class="V">She would bow down on bended knee, and</p>
<p class="V">pray that no one like him would ever</p>
<p class="V">come again</p>
<p class="V"><i>under the guise of peace.</i></p>
</blockquote>
</section>
<section epub:type="division">
<p class="pagebreak"> </p>
<h2 class="H1"><span aria-label="28" id="pg_28" role="doc-pagebreak"><b>VALUABLE</b></span></h2>
<blockquote>
<p class="V">She can be feminine and soft.</p>
<p class="V">Her strength and value aren’t comprised of</p>
<p class="V">her physique.</p>
<p class="V">Her influence on the world and what she</p>
<p class="V">offers should not be determined by a shade</p>
<p class="V">of lipstick</p>
<p class="V">or lack thereof.</p>
</blockquote>
</section>
<section epub:type="division">
<p class="pagebreak"> </p>
<h2 class="H1"><span aria-label="29" id="pg_29" role="doc-pagebreak"><b>MAZES</b></span></h2>
<blockquote>
<p class="V">I gathered my weapons:</p>
<p class="V">My wit,</p>
<p class="V">my opinions,</p>
<p class="VSB"><i>even my insecurities.</i></p>
<p class="V">I made finely honed blades of elimination,</p>
<p class="V">and I cut through the maze and carved</p>
<p class="V">my own way.</p>
<p class="V">If you stand up and object, <i>state your own</i></p>
<p class="V"><i>thoughts and opinions instead of nodding in</i></p>
<p class="V"><i>agreement,</i> you will see who has an open</p>
<p class="V">mind, and who cares only about acquiring</p>
<p class="V">sheep to support their views.</p>
</blockquote>
</section>
<section epub:type="division">
<p class="pagebreak"> </p>
<h2 class="H1"><span aria-label="30" id="pg_30" role="doc-pagebreak"><b>DESPITE IT ALL</b></span></h2>
<blockquote>
<p class="V">My life story would play somewhere between</p>
<p class="V">a ballad and a battle cry.</p>
<p class="V">Flying and falling.</p>
<p class="V">Prayers and expletives.</p>
<p class="V">Raging fists and weary arms.</p>
<p class="V">I’ve spent years climbing out of places I</p>
<p class="V">shouldn’t have been.</p>
<p class="V">I’ve spent years washing off people I should</p>
<p class="V">never have touched.</p>
<p class="V">I could waste more time blaming the world</p>
<p class="VSB">for singling me out and treating me poorly.</p>
<p class="V">I’ve decided to live richly, <i>despite it all.</i></p>
</blockquote>
</section>
<section epub:type="division">
<p class="pagebreak"> </p>
<h2 class="H1"><span aria-label="31" id="pg_31" role="doc-pagebreak"><b>RUNNING SHOES</b></span></h2>
<blockquote>
<p class="V">I was a back-row kind of soul who shunned</p>
<p class="V">the spotlight, and they all liked having</p>
<p class="VSB">someone in their shadow.</p>
<p class="VSB">In a selfish way, I loved making them glow.</p>
<p class="V">But eventually they would mistake my quiet</p>
<p class="V">for lack of interest. They would lace up</p>
<p class="V">their running shoes and sprint to the next</p>
<p class="VSB">thing that tickled the nape of their neck.</p>
<p class="V">I attracted the runners who had no idea</p>
<p class="V">that real endurance meant standing still.</p>
</blockquote>
</section>
<section epub:type="division">
<p class="pagebreak"> </p>
<h2 class="H1"><span aria-label="32" id="pg_32" role="doc-pagebreak"><b>RESILIENT</b></span></h2>
<blockquote>
<p class="V">I will put my soul</p>
<p class="V">on the witness stand</p>
<p class="V">occasionally</p>
<p class="V">and make it recite</p>
<p class="V">back to me</p>
<p class="V">all the reasons</p>
<p class="V">why I am</p>
<p class="V">resilient.</p>
</blockquote>
</section>
<section epub:type="division">
<p class="pagebreak"> </p>
<h2 class="H1"><span aria-label="33" id="pg_33" role="doc-pagebreak"><b>CARVE YOUR OWN WAY</b></span></h2>
<blockquote>
<p class="V">It won’t be easy where you are going.</p>
<p class="V">You’re not taking the scenic tour.</p>
<p class="V">You’ve chosen not to follow the sight-seers.</p>
<p class="V">The terrain is treacherous. Sometimes</p>
<p class="V">vegetation, sometimes stone. The shoreline</p>
<p class="V">you will encounter is uneven with</p>
<p class="VSB">staggered rocks.</p>
<p class="VSB">Climb slowly, but stay the course.</p>
<p class="V">You will know you’re on the right path when</p>
<p class="V">it is overgrown and not easily maneuvered.</p>
<p class="V">You will have to slash your way through with</p>
<p class="V">swords of your endurance. You will</p>
<p class="VSB">get there.</p>
<p class="V">And you will carve your own way.</p>
</blockquote>
</section>
<section epub:type="division">
<p class="pagebreak"> </p>
<h2 class="H1"><span aria-label="34" id="pg_34" role="doc-pagebreak"><b>PRESENCE</b></span></h2>
<blockquote>
<p class="V">And she realized that</p>
<p class="V">every curse,</p>
<p class="V">every spell,</p>
<p class="V">every fortune</p>
<p class="V">cast her way</p>
<p class="V">let her know</p>
<p class="V">that her presence</p>
<p class="V">had made an impact.</p>
<p class="V">Wanted or unwanted,</p>
<p class="V"><i>She was felt.</i></p>
</blockquote>
</section>
<section epub:type="division">
<p class="pagebreak"> </p>
<h2 class="H1"><span aria-label="35" id="pg_35" role="doc-pagebreak"><b>LOVING</b></span></h2>
<blockquote>
<p class="V">Someone in the dark</p>
<p class="V">may be harder to love,</p>
<p class="V">but if it is true love,</p>
<p class="V">your heart will light the way.</p>
</blockquote>
</section>
<section epub:type="division">
<p class="pagebreak"> </p>
<h2 class="H1"><span aria-label="36" id="pg_36" role="doc-pagebreak"><b>CLAW MARKS</b></span></h2>
<blockquote>
<p class="V">She has claw marks</p>
<p class="V">on her back</p>
<p class="V">from friends</p>
<p class="V">and lovers</p>
<p class="V">who would not</p>
<p class="V">allow her</p>
<p class="V">to chase</p>
<p class="V">her dreams.</p>
<p class="pagebreak"> </p>
<h2 class="H1"><span aria-label="37" id="pg_37" role="doc-pagebreak"><b>GOODNESS</b></span></h2>
<p class="V">In whatever you do</p>
<p class="V">bestow goodness</p>
<p class="V">so your trail</p>
<p class="VSB">tastes sweet.</p>
<p class="V">Don’t leave a</p>
<p class="V">sour taste</p>
<p class="V">as a memory.</p>
</blockquote>
</section>
<section epub:type="division">
<p class="pagebreak"> </p>
<h2 class="H1"><span aria-label="38" id="pg_38" role="doc-pagebreak"><b>CHAOS</b></span></h2>
<blockquote>
<p class="V">You will lie to yourself and exclaim that</p>
<p class="V">everything is right in the world because you</p>
<p class="V">are terrified to admit you have contributed</p>
<p class="V">to the chaos.</p>
</blockquote>
</section>
<section epub:type="division">
<p class="pagebreak"> </p>
<h2 class="H1"><span aria-label="39" id="pg_39" role="doc-pagebreak"><b>FAIRYTALES LIE</b></span></h2>
<blockquote>
<p class="V">How many slippery banks has she clung to,</p>
<p class="V">waiting for him to find her?</p>
<p class="V">Thinking her body needs saving and her</p>
<p class="V">life is nothing because he has not</p>
<p class="V">shown up yet.</p>
<p class="V">She searches the waters and sees nary a</p>
<p class="V">sign of his homecoming.</p>
<p class="V">And she realizes: fairytales lie.</p>
</blockquote>
</section>
<section epub:type="division">
<p class="pagebreak"> </p>
<h2 class="H1"><span aria-label="40" id="pg_40" role="doc-pagebreak"><b>UNDERFELT</b></span></h2>
<blockquote>
<p class="V">As long as people are looking for <i>quick</i></p>
<p class="V"><i>and surface</i> love, hearts will be up for</p>
<p class="V">grabs, <i>and feelings will be squandered</i></p>
<p class="VSB"><i>and underfelt.</i></p>
<p class="V">Recognize the ones who never graze, but</p>
<p class="V">feast on the sustenance of your soul.</p>
</blockquote>
</section>
<section epub:type="division">
<p class="pagebreak"> </p>
<h2 class="H1"><span aria-label="41" id="pg_41" role="doc-pagebreak"><b>SEASONAL PAIN</b></span></h2>
<blockquote>
<p class="V">You feel the pain.</p>
<p class="V">You are stretching.</p>
<p class="V">The curve of your spine</p>
<p class="V">is lengthening.</p>
<p class="V">That’s why this season hurts.</p>
<p class="V">Little by little</p>
<p class="V">you will regain your height</p>
<p class="V">after crawling for so long.</p>
</blockquote>
</section>
<section epub:type="division">
<p class="pagebreak"> </p>
<h2 class="H1"><span aria-label="42" id="pg_42" role="doc-pagebreak"><b>MAJESTIC</b></span></h2>
<blockquote>
<p class="V">If you are majestic, you will stand out no</p>
<p class="V">matter the scenery that tries to hide your</p>
<p class="V">budding foliage.</p>
<p class="V">Fall, with all its wonder, still paints</p>
<p class="V">with brushstrokes,</p>
<p class="V">even though Winter threatens to cover</p>
<p class="V">its masterpiece.</p>
</blockquote>
</section>
<section epub:type="division">
<p class="pagebreak"> </p>
<h2 class="H1"><span aria-label="43" id="pg_43" role="doc-pagebreak"><b>HOSTAGE</b></span></h2>
<blockquote>
<p class="V">Even though his memory holds her hostage,</p>
<p class="V">she will never let him put a bullet</p>
<p class="V">in her head.</p>
</blockquote>
</section>
<section epub:type="division">
<p class="pagebreak"> </p>
<h2 class="H1"><span aria-label="44" id="pg_44" role="doc-pagebreak"><b>HARNESS</b></span></h2>
<blockquote>
<p class="V">They think she is lifeless</p>
<p class="V">because she is numb to heartache.</p>
<p class="V">But if you inch a little closer</p>
<p class="VSB">you might hear a steady hum.</p>
<p class="V">If you could harness the energy</p>
<p class="V">she holds at bay,</p>
<p class="V">it could power the darkness</p>
<p class="V">in countless heartbroken souls.</p>
</blockquote>
</section>
<section epub:type="division">
<p class="pagebreak"> </p>
<h2 class="H1"><span aria-label="45" id="pg_45" role="doc-pagebreak"><b>INTRIGUED</b></span></h2>
<blockquote>
<p class="V">I admit it.</p>
<p class="V">It used to turn me on.</p>
<p class="V">Hypnotic eyes and vague responses.</p>
<p class="V">He made me work for it. I was looking for</p>
<p class="V">the treasure others were not cunning</p>
<p class="VSB">enough to find.</p>
<p class="V">I admit it.</p>
<p class="V">I was intrigued.</p>
<p class="V">Rolled up like a fishing line</p>
<p class="V">while his rod and reel were casting</p>
<p class="VSB">in any and every sea.</p>
<p class="V">Mystery used to intrigue me.</p>
<p class="V">Now transparency does.</p>
<p class="V">I grew up.</p>
<p class="V">I grew wise.</p>
<p class="V">Thank God I outgrew you.</p>
</blockquote>
</section>
<section epub:type="division">
<p class="pagebreak"> </p>
<h2 class="H1"><span aria-label="46" id="pg_46" role="doc-pagebreak"><b>BAGS</b></span></h2>
<blockquote>
<p class="V">Is tomorrow ready</p>
<p class="V">for your bags of yesterday?</p>
<p class="V">Even a sunrise gets weary</p>
<p class="V">from shouldering yesterday’s sunset.</p>
</blockquote>
</section>
<section epub:type="division">
<p class="pagebreak"> </p>
<h2 class="H1"><span aria-label="47" id="pg_47" role="doc-pagebreak"><b>BROKEN</b></span></h2>
<blockquote>
<p class="V">You label her broken</p>
<p class="V">because she used to hold hands</p>
<p class="V">and walk as two,</p>
<p class="V">yet she stands before you</p>
<p class="V">today—alone and whole.</p>
<p class="V"><i>Separation</i> does not</p>
<p class="V">mean broken.</p>
</blockquote>
</section>
<section epub:type="division">
<p class="pagebreak"> </p>
<h2 class="H1"><span aria-label="48" id="pg_48" role="doc-pagebreak"><b>INVITATION</b></span></h2>
<blockquote>
<p class="V">If she invites you in,</p>
<p class="V">will you make your time</p>
<p class="V">count?</p>
</blockquote>
</section>
<section epub:type="division">
<p class="pagebreak"> </p>
<h2 class="H1"><span aria-label="49" id="pg_49" role="doc-pagebreak"><b>PERMISSION</b></span></h2>
<blockquote>
<p class="V">I give myself permission</p>
<p class="V">to let the past be cast</p>
<p class="V">out to sea.</p>
<p class="V">To let the waves</p>
<p class="V">roll with hope.</p>
<p class="V">To let the tide</p>
<p class="V">excite the future.</p>
<p class="V">I give myself permission</p>
<p class="V">to accept the happiness</p>
<p class="V">I have denied myself</p>
<p class="V">for so long.</p>
</blockquote>
</section>
<section epub:type="division">
<p class="pagebreak"> </p>
<h2 class="H1"><span aria-label="50" id="pg_50" role="doc-pagebreak"><b>ATHLETE</b></span></h2>
<blockquote>
<p class="V">How many belongings will you hurtle,</p>
<p class="V">and egos will you feed</p>
<p class="V">while you let your life ebb</p>
<p class="V">at the hands of someone</p>
<p class="V">who told the world</p>
<p class="V"><i>they were stronger</i></p>
<p class="V">than you.</p>
</blockquote>
</section>
<section epub:type="division">
<p class="pagebreak"> </p>
<h2 class="H1"><span aria-label="51" id="pg_51" role="doc-pagebreak"><b>SLOWLY</b></span></h2>
<blockquote>
<p class="V">You’ve learned this time, haven’t you? You’ll</p>
<p class="VSB">take the next one slower.</p>
<p class="V">You’ve learned that there are things</p>
<p class="V">that must be savored and drunk a little</p>
<p class="VSB">at a time.</p>
<p class="V">Coffee, bourbon, men.</p>
</blockquote>
</section>
<section epub:type="division">
<p class="pagebreak"> </p>
<h2 class="H1"><span aria-label="52" id="pg_52" role="doc-pagebreak"><b>THIEVES</b></span></h2>
<blockquote>
<p class="V">We tell them our secrets</p>
<p class="V">because they led us to believe</p>
<p class="V">they have safes in their chests.</p>
<p class="V">But they are collectors,</p>
<p class="V">and our precious truths</p>
<p class="V">become possessions.</p>
</blockquote>
</section>
<section epub:type="division">
<p class="pagebreak"> </p>
<h2 class="H1"><span aria-label="53" id="pg_53" role="doc-pagebreak"><b>REHAB</b></span></h2>
<blockquote>
<p class="V">He has noticed your independent nature and</p>
<p class="VSB">he is intrigued.</p>
<p class="V">When he realizes he can’t be your savior,</p>
<p class="VSB">he will change tactics.</p>
<p class="V">He will become misunderstood, and broken,</p>
<p class="VSB">and in need of saving.</p>
<p class="V">Before you embark on this rehab, pack a bag</p>
<p class="VSB">stuffed full of self-love.</p>
<p class="V">You’re going to need it.</p>
</blockquote>
</section>
<section epub:type="division">
<p class="pagebreak"> </p>
<h2 class="H1"><span aria-label="54" id="pg_54" role="doc-pagebreak"><b>UNSEEN</b></span></h2>
<blockquote>
<p class="V">It can feel like it is too much to bear when</p>
<p class="V">the world is out to get you, but always</p>
<p class="V">remember that you are your own worst</p>
<p class="V">enemy. You never know if the person you lost</p>
<p class="V">patience with today has lost patience with</p>
<p class="VSB">themselves as well.</p>
<p class="V">We need to think before we act out</p>
<p class="V">emotionally. Our actions can cause another</p>
<p class="V">soul to tip over when they have been barely</p>
<p class="VSB">holding their own.</p>
<p class="V">We should be throwing life preservers into</p>
<p class="V">the ocean of humanity, not bodies.</p>
</blockquote>
</section>
<section epub:type="division">
<p class="pagebreak"> </p>
<h2 class="H1"><span aria-label="55" id="pg_55" role="doc-pagebreak"><b>REAL MAN</b></span></h2>
<blockquote>
<p class="V">Do you know how I define the strength</p>
<p class="V">of a man?</p>
<p class="V">When he does not rely on his physique to</p>
<p class="V">show the world he is strong.</p>
</blockquote>
</section>
<section epub:type="division">
<p class="pagebreak"> </p>
<h2 class="H1"><span aria-label="56" id="pg_56" role="doc-pagebreak"><b>ROAD TRIP</b></span></h2>
<blockquote>
<p class="V">If you are going to ride all over me, let</p>
<p class="V">me feel the tread. My body is used to wear.</p>
<p class="V">The tracks down my back are mistaken for</p>
<p class="V">tattoos. I once let people like you imprint</p>
<p class="V">me in the asphalt because it was easier</p>
<p class="V">than having to get up and walk the road</p>
<p class="VSB">of self-love.</p>
<p class="V">I will not be your dirt track, pothole, or</p>
<p class="V">the curb that you drive over. I am a woman</p>
<p class="V">with an unflinching heart that has traveled</p>
<p class="V">the world via my nightmares. So if the</p>
<p class="V">thrill of the race is your motivation, then</p>
<p class="V">by all means push the pedal to the floor.</p>
<p class="V">You may run me over, but I will never be</p>
<p class="V">your casualty.</p>
</blockquote>
</section>
<section epub:type="division">
<p class="pagebreak"> </p>
<h2 class="H1"><span aria-label="57" id="pg_57" role="doc-pagebreak"><b>WE JUST GO ON</b></span></h2>
<blockquote>
<p class="V">What do I tell them as I watch their hearts</p>
<p class="V">crumble and the strength leak from their</p>
<p class="V">souls? Do I lie and say everything happens</p>
<p class="V">for a reason, and <i>it was for the best,</i> or do I</p>
<p class="V">offer my own heart up and show them that</p>
<p class="V">even in pieces, <i>we find a way to go on?</i></p>
</blockquote>
</section>
<section epub:type="division">
<p class="pagebreak"> </p>
<h2 class="H1"><span aria-label="58" id="pg_58" role="doc-pagebreak"><b>BREAKING THE CYCLE</b></span></h2>
<blockquote>
<p class="V">I wonder why we commit to relationships so</p>
<p class="V">early? We jump from childhood into adult-</p>
<p class="V">hood and immediately think we need to find</p>
<p class="V">the one we will share our life with. We do</p>
<p class="V">this before we learn more about the person</p>
<p class="V">we are choosing to care for, for better or</p>
<p class="VSB">worse. Then our hearts are restless.</p>
<p class="V">We untie the knots. We begin again. And</p>
<p class="V">chances are we will do it all over again</p>
<p class="V">in other relationships. We create cycles</p>
<p class="V">and wonder why we keep picking the wrong</p>
<p class="V">ones. We are always searching for the</p>
<p class="V">one we think is going to save our</p>
<p class="VSB">misunderstood heart.</p>
<p class="V"><span aria-label="59" id="pg_59" role="doc-pagebreak">And after reckless decisions and too many</span></p>
<p class="V">beginnings to count, you will have no choice</p>
<p class="V">but to do some soul searching. You will</p>
<p class="V">ultimately see that a lasting relationship</p>
<p class="V">starts with you protecting and respecting</p>
<p class="V">your heart enough to break the cycle. You</p>
<p class="V">get what you offer, and if you are offering a</p>
<p class="V">chest full of the past, you will attract the</p>
<p class="VSB">same thing.</p>
<p class="V">Change starts with you.</p>
</blockquote>
</section>
<section epub:type="division">
<p class="pagebreak"> </p>
<h2 class="H1"><span aria-label="60" id="pg_60" role="doc-pagebreak"><b>WASTED</b></span></h2>
<blockquote>
<p class="V">I don’t want to live in a world where</p>
<p class="V">people are more vehement about</p>
<p class="V">believing in <i>nothing</i> rather than</p>
<p class="VSB">believing in <i>something.</i></p>
<p class="V">Such an emotive force wasted.</p>
</blockquote>
</section>
<section epub:type="division">
<p class="pagebreak"> </p>
<h2 class="H1"><span aria-label="61" id="pg_61" role="doc-pagebreak"><b>BROKEN LOVE</b></span></h2>
<blockquote>
<p class="V">Even when I loved until I broke,</p>
<p class="V">every piece still formed a kaleidoscope</p>
<p class="V">of love for you.</p>
<p class="V">Because even in fractions,</p>
<p class="V">broken love still equates</p>
<p class="V">to whole love.</p>
</blockquote>
</section>
<section epub:type="division">
<p class="pagebreak"> </p>
<h2 class="H1"><span aria-label="62" id="pg_62" role="doc-pagebreak"><b>TANKED</b></span></h2>
<blockquote>
<p class="V">There is a difference between someone who</p>
<p class="V">encourages you to keep going because they</p>
<p class="V">want to see you achieve <i>your dreams,</i> and</p>
<p class="V">someone who pushes you because you help</p>
<p class="V"><i>fulfill theirs.</i> As soon as you lose value</p>
<p class="V">for their cause, they’ll run right over you</p>
<p class="V">and keep moving.</p>
</blockquote>
</section>
<section epub:type="division">
<p class="pagebreak"> </p>
<h2 class="H1"><span aria-label="63" id="pg_63" role="doc-pagebreak"><b>UNCONDITIONAL ACCEPTANCE</b></span></h2>
<blockquote>
<p class="V">Offer unconditional acceptance to yourself</p>
<p class="V">before imparting it to those you love.</p>
<p class="V">Acceptance is tiered.</p>
<p class="V">Tier One: You.</p>
</blockquote>
</section>
<section epub:type="division">
<p class="pagebreak"> </p>
<h2 class="H1"><span aria-label="64" id="pg_64" role="doc-pagebreak"><b>IMPOSTERS</b></span></h2>
<blockquote>
<p class="V">Some people are chameleons.</p>
<p class="V">They change their likes,</p>
<p class="V">their dislikes,</p>
<p class="V">even their personalities</p>
<p class="V">to fit in with whatever</p>
<p class="V">crowd they are trying</p>
<p class="VSB">to impress.</p>
<p class="V">It’s okay to like these people,</p>
<p class="V">as it’s almost impossible</p>
<p class="V"><i>to avoid them</i> entirely.</p>
<p class="V"><i>But don’t ever</i> fall in love</p>
<p class="V">with one of them.</p>
</blockquote>
</section>
<section epub:type="division">
<p class="pagebreak"> </p>
<h2 class="H1"><span aria-label="65" id="pg_65" role="doc-pagebreak"><b>HALF FULL</b></span></h2>
<blockquote>
<p class="V">Don’t be half the person</p>
<p class="V"><i>you really are</i></p>
<p class="V">because you think</p>
<p class="V">you need to downplay</p>
<p class="V">your strength</p>
<p class="V">to attract the right one.</p>
</blockquote>
</section>
<section epub:type="division">
<p class="pagebreak"> </p>
<h2 class="H1"><span aria-label="66" id="pg_66" role="doc-pagebreak"><b>DEFINING</b></span></h2>
<blockquote>
<p class="V">People will try to define you by your</p>
<p class="V">education, job title, and the amount of</p>
<p class="V">material possessions you own. Having these</p>
<p class="V">things isn’t bad, <i>if you do not let them</i></p>
<p class="V"><b>define you.</b></p>
</blockquote>
</section>
<section epub:type="division">
<p class="pagebreak"> </p>
<h2 class="H1"><span aria-label="67" id="pg_67" role="doc-pagebreak"><b>BULLIES</b></span></h2>
<blockquote>
<p class="V">We walk heavy when we feel that we don’t</p>
<p class="V">measure up. We store our opinions within</p>
<p class="V">every blood cell in our bodies. Our hearts</p>
<p class="V">feed off our self-imposed unworthiness.</p>
<p class="V"><i>We are the bullies.</i> We bully ourselves into</p>
<p class="V">thinking we are levels below our neighbors,</p>
<p class="VSB">family, and friends.</p>
<p class="V">Once we reach down deep and start</p>
<p class="V">emptying the judgment and the jealousy</p>
<p class="V">we’ve stored for others, <i>we can work on</i></p>
<p class="V"><i>walking lighter.</i></p>
</blockquote>
</section>
<section epub:type="division">
<p class="pagebreak"> </p>
<h2 class="H1"><span aria-label="68" id="pg_68" role="doc-pagebreak"><b>SAFETY</b></span></h2>
<blockquote>
<p class="V">I grew up, like most fairytale lovers,</p>
<p class="V">wanting a big strong man to save me and</p>
<p class="V">twirl me around the world. Strength has</p>
<p class="V">always equated to safety in my eyes.</p>
<p class="V">I thought the stronger the man, the</p>
<p class="VSB">safer I would be.</p>
<p class="V"><i>This is where I was wrong.</i></p>
<p class="VSB">This is why I chose wrong.</p>
<p class="V">I learned that mental strength and heart</p>
<p class="V">strength have no bearing on outward</p>
<p class="V">appearance or physical strength. And arms</p>
<p class="V">that uplift you should never be used to</p>
<p class="V">subdue you.</p>
</blockquote>
</section>
<section epub:type="division">
<p class="pagebreak"> </p>
<h2 class="H1"><span aria-label="69" id="pg_69" role="doc-pagebreak"><b>REPEATING</b></span></h2>
<blockquote>
<p class="V">You’re not going to wake up one morning and</p>
<p class="V">suddenly feel like a new person</p>
<p class="V">unless you took steps</p>
<p class="V">the day before</p>
<p class="V">to ensure you won’t repeat</p>
<p class="V">the things</p>
<p class="V"><i>you have always repeated.</i></p>
</blockquote>
</section>
<section epub:type="division">
<p class="pagebreak"> </p>
<h2 class="H1"><span aria-label="70" id="pg_70" role="doc-pagebreak"><b>CHANGE</b></span></h2>
<blockquote>
<p class="V">Who says people cannot change?</p>
<p class="V">I know I have. I’m sure if you think about</p>
<p class="V">your life, <i>then</i> versus <i>now,</i> you know you’re</p>
<p class="V">not the same person either.</p>
</blockquote>
</section>
<section epub:type="division">
<p class="pagebreak"> </p>
<h2 class="H1"><span aria-label="71" id="pg_71" role="doc-pagebreak"><b>WEAKNESS</b></span></h2>
<blockquote>
<p class="V">When they try to change you</p>
<p class="V">it is usually because something</p>
<p class="V">within them is too weak</p>
<p class="V">to handle that part</p>
<p class="V">of you.</p>
</blockquote>
</section>
<section epub:type="division">
<p class="pagebreak"> </p>
<h2 class="H1"><span aria-label="72" id="pg_72" role="doc-pagebreak"><b>DOORBELL</b></span></h2>
<blockquote>
<p class="V">You’ll know when true love</p>
<p class="V">knocks on the door.</p>
<p class="V">It never rings</p>
<p class="V">the doorbell</p>
<p class="V">politely.</p>
</blockquote>
</section>
<section epub:type="division">
<p class="pagebreak"> </p>
<h2 class="H1"><span aria-label="73" id="pg_73" role="doc-pagebreak"><b>GROWING</b></span></h2>
<p class="V">And what happened</p>
<p class="V">when her stature</p>
<p class="V">grew in confidence</p>
<p class="VSB">and strength?</p>
<p class="V">Her beauty intensified.</p>
</section>
<section epub:type="division">
<p class="pagebreak"> </p>
<h2 class="H1"><span aria-label="74" id="pg_74" role="doc-pagebreak"><b>BOUNDARIES</b></span></h2>
<blockquote>
<p class="V">How many promises to yourself have</p>
<p class="V">you broken? This is why you allow others</p>
<p class="V">to do the same.</p>
</blockquote>
</section>
<section epub:type="division">
<p class="pagebreak"> </p>
<h2 class="H1"><span aria-label="75" id="pg_75" role="doc-pagebreak"><b>ENCOURAGEMENT</b></span></h2>
<blockquote>
<p class="V">Let’s encourage those</p>
<p class="V">looking up to us.</p>
<p class="V">Let’s share with our daughters</p>
<p class="V">that Vikings</p>
<p class="V">do not have to be male.</p>
</blockquote>
</section>
<section epub:type="division">
<p class="pagebreak"> </p>
<h2 class="H1"><span aria-label="76" id="pg_76" role="doc-pagebreak"><b>DAGGERS</b></span></h2>
<blockquote>
<p class="V">Do you see the daggers</p>
<p class="V">in her back</p>
<p class="V">as she walks away?</p>
<p class="V">She knows they are there,</p>
<p class="V">yet she still</p>
<p class="V">moves forward.</p>
</blockquote>
</section>
<section epub:type="division">
<p class="pagebreak"> </p>
<h2 class="H1"><span aria-label="77" id="pg_77" role="doc-pagebreak"><b>EVOLUTION</b></span></h2>
<blockquote>
<p class="V">I am an evolution.</p>
<p class="V">My arms have strengthened</p>
<p class="V">from holding burdens meant to break them.</p>
<p class="V">My chest, from loving until it is full.</p>
<p class="V">My mouth, from harnessing the wind</p>
<p class="VSB">to give it a voice.</p>
<p class="V">I have evolved.</p>
<p class="V">I am renewed strength, suppressed</p>
<p class="V">for generations.</p>
</blockquote>
</section>
<section epub:type="division">
<p class="pagebreak"> </p>
<h2 class="H1"><span aria-label="78" id="pg_78" role="doc-pagebreak"><b>WISDOM</b></span></h2>
<blockquote>
<p class="V">Are you going</p>
<p class="V">to listen</p>
<p class="V">to wisdom,</p>
<p class="V">or to what</p>
<p class="V">your heart</p>
<p class="V">wants to hear.</p>
</blockquote>
</section>
<section epub:type="division">
<p class="pagebreak"> </p>
<h2 class="H1"><span aria-label="79" id="pg_79" role="doc-pagebreak"><b>SUPPORTERS</b></span></h2>
<blockquote>
<p class="V">Mouths that swore</p>
<p class="V">to support her</p>
<p class="V">ravished her.</p>
<p class="V">Yet she still</p>
<p class="V">carried on,</p>
<p class="V">and left</p>
<p class="V">their egos</p>
<p class="V">hungry.</p>
</blockquote>
</section>
<section epub:type="division">
<p class="pagebreak"> </p>
<h2 class="H1"><span aria-label="80" id="pg_80" role="doc-pagebreak"><b>WHAT COULD KILL HER?</b></span></h2>
<blockquote>
<p class="V">She stood up</p>
<p class="V">and faced them.</p>
<p class="V">What could kill her</p>
<p class="V">if she had already walked around</p>
<p class="V">dead inside</p>
<p class="V">for half her life?</p>
</blockquote>
</section>
<section epub:type="division">
<p class="pagebreak"> </p>
<h2 class="H1"><span aria-label="81" id="pg_81" role="doc-pagebreak"><b>BOLD</b></span></h2>
<blockquote>
<p class="V">She is bold <i>today.</i></p>
<p class="V">She tingles with heightened senses.</p>
<p class="V">Her defenses are tight.</p>
<p class="V">Whatever life throws at her,</p>
<p class="V">she can handle it today.</p>
<p class="V">Because we all have a little Viking in us.</p>
</blockquote>
</section>
<section epub:type="division">
<p class="pagebreak"> </p>
<h2 class="H1"><span aria-label="82" id="pg_82" role="doc-pagebreak"><b>THE SHOW MUST GO ON</b></span></h2>
<blockquote>
<p class="V">Playing to a hostile audience every</p>
<p class="V">time you hit the stage does little for</p>
<p class="V">your self-confidence.</p>
<p class="V">But the show must go on.</p>
</blockquote>
</section>
<section epub:type="division">
<p class="pagebreak"> </p>
<h2 class="H1"><span aria-label="83" id="pg_83" role="doc-pagebreak"><b>IMMUNE</b></span></h2>
<blockquote>
<p class="V">Walk straight and look the enemy in the eye.</p>
<p class="V">I don’t care if their stare is bedroom blue</p>
<p class="V">or brimstone red, <i>stay focused.</i></p>
<p class="V">Head up. Meet this fear head on.</p>
<p class="V">You need this. Your soul needs this.</p>
<p class="V">Stand your ground.</p>
<p class="V">There is not a person in this universe that</p>
<p class="VSB">carries more worth than you.</p>
<p class="V">I know you are fearful, but always remember</p>
<p class="V">that their worries mirror yours.</p>
<p class="V">They <i>are not</i> immune to fear.</p>
</blockquote>
</section>
<section epub:type="division">
<p class="pagebreak"> </p>
<h2 class="H1"><span aria-label="84" id="pg_84" role="doc-pagebreak"><b>RESERVATIONS</b></span></h2>
<blockquote>
<p class="V">We have reservations with the clock.</p>
<p class="V">It leans left and we lean with it, and the</p>
<p class="V">regrets tick tock for us to reminisce.</p>
<p class="V">We lean right, and it does not move as</p>
<p class="V">quickly, and we are so impatient.</p>
<p class="V">This clock holds us spellbound, and we</p>
<p class="V">divide our lives by before and after.</p>
<p class="V">The past on one side, the future</p>
<p class="V">on the other.</p>
<p class="V">We stand transfixed in the center,</p>
<p class="V">unable to turn back,</p>
<p class="V">but dreading the movement of the</p>
<p class="V">clock’s hands.</p>
</blockquote>
</section>
</section>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chapter1.vue?ded0adee